// src/i18n/en.js
export default {
  lang: {
    current: "English",
    zh: "中文",
    en: "English"
  },
  menu: {
    home: "Home Page",
    meetingInfo: {
      base: 'Conference Information',
      sub:{
        info: 'Conference Overview',
        guests: 'Conference Guests',
        schedule: 'Meeting Schedule',
        org: 'Organization Structure'
      }
    },
    submitPaper: 'Submission Information',
    register: 'Registration Fees',
    accommodation: 'Accommodation Transportation',
    contact: 'Contact Us'
  },
  common: {
    tip: 'Tip',
    confirm: 'Confirm',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    unit: '',
    cancelInfo: 'Operation cancelled',
    edit: 'Edit',
    back: 'Back',
    download: 'Download',
    labelAttachments: 'Attachments'
  },
  order: {
    summary: '{count} orders',
    badges: '{count} badges',
    unit: {
      orders: 'orders',
      badges: 'badges'
    },
    registerNow: 'Register Now',
    button:{
      payNow: 'Pay Now',
      cancel: 'Cancel Order',
      applyRefund: 'Apply Refund',
      applyInvoice: 'Apply Invoice',
      viewSurvey: 'Acc.',
      needHotelRoom: 'Do you require accommodation?',
      yes: 'Yes',
      no: 'No'
    },
    refund: {
      confirmMessage: 'Are you sure you want to apply for refund? The refund amount is ¥{amount} yuan.',
      confirm: 'Apply Refund'
    },
    invoice: {
      confirmMessage: 'Are you sure you want to apply for invoice? The invoice amount is ¥{amount} yuan.',
      confirm: 'Apply Invoice'
    },
    cancelConfirm: 'Are you sure you want to cancel this order? This action cannot be undone.',
    cancelSuccess: 'Order cancelled successfully',
    cancelFailed: 'Failed to cancel order',
    cancelInfo: 'Operation cancelled',
    paySuccess: 'Payment successful!',
    payFailed: 'Order not paid, please pay first',
    payConfirmSuccess: 'Payment confirmation submitted successfully',
    payConfirmFailed: 'Payment confirmation failed, please try again',
    createFailed: 'Order creation failed, please check and try again',
    createSuccess: 'Registration verified, order created successfully',
    paymentConfigFailed: 'Failed to get payment configuration, please try again',
    eventEnded: 'Event has ended~',
    defaultSubject: 'Order Payment',
    loadFailed: 'Failed to load orders',
    badgeLoadFailed: 'Failed to load badges',
    payment: {
      dialogTitle: 'Payment',
      subjectLabel: 'Charge Item:',
      wechatPay: 'WeChat Pay',
      alipay: 'Alipay',
      bankTransfer: 'Bank Transfer',
      scanTip: 'Please scan QR code with {payType}',
      finishTip: 'After payment, click "I have paid"',
      receiveUnit: 'Payee:',
      bankNo: 'Account No.:',
      bankBranch: 'Bank Branch:',
      uploadTip: 'Please upload transfer screenshot after payment (jpg/png only, max 1 file)',
      selectImageBtn: 'Select Screenshot',
      selectedFile: 'Selected: {name}',
      btnPaid: 'I Have Paid',
      btnSubmitProof: 'Submit Transfer Screenshot',
      msgSelectFile: 'Please select transfer screenshot first!',
      msgChargeInitWait: 'Payment channel initializing, please wait!',
      msgProofSuccess: 'Transfer proof submitted, pending verification by staff!',
      msgProofFail: 'Submit failed',
      msgUploadFail: 'Upload failed, please try again',
      msgOnlyOneImage: 'Only one image can be uploaded!'
    }
  },
  content: {
    brief: {
      title: 'Conference Overview',
      desc: 'This conference focuses on the safety issues of key load-bearing structures in major engineering fields such as high-speed railways, aero-space, advanced manufacturing. and energy equipment. Academic exchanges wil be conducted in the areas of engineering defect me-chanics, fatigue fracture, damage tolerance design, structural reliabiity evauation, advanced experimental testing,and numerical simulation to promote cooperation between domestic and foreign scholars and engineering technicians in related fields.',
    },
    guest: {
      title: 'Conference Guests',
      chair: 'Chair',
      honorChair: 'Honor Chair'
    },
    schedule: {
      title: 'Meeting Schedule',
      main: 'Main Forum',
      sub: 'Sub-forum',
      handbook: 'Download Conference Program'
    },
    organization: {
      title: 'Organization Structure',
      host: 'Host Institution',
      co: 'Co-organizers',
      undertake: 'Organizer',
    },
    contact:{
      location: {
        title: 'Address',
        content: '23rd Floor, Block A, Jinqiu International Building, No. 6 Zhichun Road, Haidian District, Beijing'
      },
      telephone: {
        title: 'Telephone',
        content: '010-82800755'
      },
      fax: {
        title: 'Fax',
        content: '010-82800879'
      },
      email: {
        title: 'Email',
        content: 'info@cis.org.cn'
      }
    },
    order: {
      title: 'Order Information',
      orderno: 'Order Number',
      subject: 'Order Content',
      amount: 'Order Amount',
      paytime: 'Payment Time',
      status: {
        refund_apply: 'Refund application in progress',
        refund_pending: 'Refund pending',
        refunded:'Refunded',
        completed: 'Completed',
        free: 'Free',
        expired: 'Expired',
        cancel: 'Canceled',
        online: 'Online Payment',
        bank: 'Bank Transfer',
        pending: 'Pending Payment',
        void: 'Voided',
        delete: 'Deleted',
        bank_pending: 'Bank Transfer Pending'
      }
    },
    badge:{
      title: 'Registration Badge',
      qr:{
        tip: 'Please show this QR code at the conference'
      },
      unit: 'Badge'
    }
  },
  register:{
    fillInfo: 'Fill in the information below',
    attendee: 'Attendee',
    submit: 'Submit',
    reset: 'Reset',
    placeholder: {
      common: 'Please input '
    },
    realname: 'Full Name',
    country: 'Country',
    cellphone: 'Phone Number',
    company: 'Company/Institution',
    title: 'Job Title',
    email: 'Email',
    gender: 'Gender',
    position: 'Position',
    department: 'Department',
    institution: 'Institution',
    address: 'Address',
    memo: 'Memo',
    idtype: 'ID Type',
    idnumber: 'ID Number',
    ethnicity: 'Ethnicity',
    birthdate: 'Birth Date',
    ticket:{
      title: 'Select Ticket Type'
    },
    amount: {
      free: "Free"
    },
    validateError: 'Please complete all attendee information',
    ticketTotal: 'Total {count} tickets, total price: ¥{price}',
    viewRegisteredInfo: 'View Registered Information'
  },
  manuscript: {
    uploadAvatar: "Upload Author Photo",
    uploadAvatarTip: "Click to upload author ID photo",
    notice: "Submission Notice",
    notice1: "Only JPG format, file ≤ 500KB",
    notice2: "Chinese and English manuscript templates available for download",
    notice3: "Supported formats: PDF, PPT, PPTX, JPG. Max size 20MB",
    templateZh: "Chinese Manuscript Template",
    templateEn: "English Manuscript Template",
    download: "Download",
    uploadFile: "Upload File",
    uploadFileTip: "Upload final document",
    uploadFileAction: "Click to select file",
    requiredTip: "Required field, file must be uploaded",
    formTitle: "Submission Info",
    saveEditBtn: "Save Changes",
    submitBtn: "Submit",
    labelAuthorFirst: "Full Name",
    placeholderAuthorFirst: "Please input author name",
    labelPhone: "Phone Number",
    placeholderPhone: "Please input Phone number",
    labelEmail: "Email",
    placeholderEmail: "Please input email address",
    labelPublishCompany: "Institution",
    placeholderPublishCompany: "Please input your institution",
    labelPosterTitle: "Title",
    placeholderPosterTitle: "Please input title",
    uploadFileRequired:"Please upload file",
    submitSuccess: "Submission Successful",
    submitFailed: "Submission Failed",
    submitTime: "Submission Time",
    submitAgain: "Submit Again",
    editTitle: "Edit",
    updateBtn: "Submit Changes",
    updateSuccess:"Update Successful",
    labelAttachments:"Attachments",
    total:"Total {count} manuscripts",
    fileToal: "Total {count} files",
    topicTitle: "1.Call for Papers Topics",
    labelAbstract: "Topic",
    placeholderAbstract: "Please select topic",
    topicList: [
      "Engineering Defect Mechanics and Service Safety of Major Equipment",
      "Fatigue and Fracture Mechanisms and Damage-Tolerant Design",
      "Advanced Materials and Design and Assessment of Lightweight Structures",
      "Advanced Testing and Characterization, Numerical Simulation, and Engineering Applications",
      "Physics-Informed Machine Learning Modeling Methods and Applications",
      "Damage, Fracture, and Service Safety of Composite Materials"
    ],
    formatTitle: "2.Submission Format",
    formatText: "Original abstracts or full papers",
    formatTime:"3.Submission Deadline",
    formatTimeTip:"2026, October 10th",
    channelClosed:"Submission channel closed"
   },
   footer:{
    friendLink:"Links",
    bjtu:"BEIJING JIAOTONG UNIVERSITY",
    imech:"Institute of Mechanics Chinese Academy of Sciences",
    swjtu:"Southwest Jiaotong University",
    cstam:"The Chinese Society of Theoretical and Applied Mechanics"
   }
}